var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3866 18.9701C23.3471 14.375 26.9458 12.1384 27.1118 12.0332C25.073 8.89289 21.912 8.46361 20.8026 8.4302C18.149 8.13455 15.576 10.1089 14.2231 10.1089C12.8449 10.1089 10.7635 8.45859 8.52077 8.50871C5.63484 8.55548 2.93225 10.3227 1.45135 13.0654C-1.60527 18.6578 0.675345 26.8776 3.60237 31.3976C5.06746 33.6124 6.7791 36.0862 9.0202 35.9977C11.2123 35.9025 12.031 34.5195 14.6767 34.5195C17.2987 34.5195 18.0668 35.9977 20.3521 35.9426C22.7039 35.9025 24.1863 33.7177 25.6009 31.4827C27.2935 28.9455 27.9731 26.445 28 26.318C27.9447 26.298 23.4309 24.479 23.3866 18.9701Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.024 5.83114C21.2623 4.27271 22.1088 2.15306 21.8748 0C20.0821 0.080176 17.8413 1.24774 16.5499 2.77275C15.4079 4.1157 14.3887 6.3172 14.651 8.38675C16.6644 8.53875 18.7326 7.3645 20.024 5.83114Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/apple_store.4ed02a8d.svg";
export { ForwardRef as ReactComponent };